import { GlobeAltIcon, PuzzlePieceIcon } from '@heroicons/react/24/outline';

export const WORKER_TYPES = {
  PARSER: 'URL_PARSER',
  PREBUILD: 'PREBUILD',
};

export const WORKERS_PAGE_SIZE = 10;
export const TOTAL_ALLOWED_WORKERS = 50;

export const WORKER_TYPES_LABELS = {
  [WORKER_TYPES.PARSER]: 'Parser',
  [WORKER_TYPES.PREBUILD]: 'Prebuild',
};

export const WORKER_TYPES_OPTIONS = [
  { value: WORKER_TYPES.PARSER, label: `${WORKER_TYPES_LABELS[WORKER_TYPES.PARSER]} Worker`, description: 'Extract data from a website using regex or JSON path' },
  { value: WORKER_TYPES.PREBUILD, label: `${WORKER_TYPES_LABELS[WORKER_TYPES.PREBUILD]} Worker`, description: 'Select from a list of ready-to-use workers' },
];

export const WORKER_TYPE_ICONS = {
  [WORKER_TYPES.PARSER]: GlobeAltIcon,
  [WORKER_TYPES.PREBUILD]: PuzzlePieceIcon,
};

export const WORKER_PARSER_METHODS = {
  GET: 'GET',
  POST: 'POST',
};

export const WORKER_PARSER_METHODS_OPTIONS = [
  { value: WORKER_PARSER_METHODS.GET, label: 'GET' },
  { value: WORKER_PARSER_METHODS.POST, label: 'POST' },
];

export const WORKER_PARSER_VALIDATION_TYPES = {
  REGEX: 'REGEX',
  JSON: 'JSON',
};

export const WORKER_PARSER_VALIDATION_TYPES_LABELS = {
  [WORKER_PARSER_VALIDATION_TYPES.REGEX]: 'Regex',
  [WORKER_PARSER_VALIDATION_TYPES.JSON]: 'JSON Path',
};

export const WORKER_PARSER_VALIDATION_TYPES_OPTIONS = [
  { value: WORKER_PARSER_VALIDATION_TYPES.REGEX, label: WORKER_PARSER_VALIDATION_TYPES_LABELS[WORKER_PARSER_VALIDATION_TYPES.REGEX] },
  { value: WORKER_PARSER_VALIDATION_TYPES.JSON, label: WORKER_PARSER_VALIDATION_TYPES_LABELS[WORKER_PARSER_VALIDATION_TYPES.JSON] },
];

export const WORKER_PATH_OPERATIONS = {
  NONE: 'NONE',
  GT: '>',
  GTE: '>=',
  LT: '<',
  LTE: '<=',
  EQ: '==',
  NEQ: '!=',
  CONTAINS: 'CONTAINS'
};

export const WORKER_PATH_OPERATIONS_LABELS = {
  [WORKER_PATH_OPERATIONS.NONE]: 'Exists',
  [WORKER_PATH_OPERATIONS.GT]: 'Greater than (>)',
  [WORKER_PATH_OPERATIONS.GTE]: 'Greater than or equal (>=)',
  [WORKER_PATH_OPERATIONS.LT]: 'Less than (<)',
  [WORKER_PATH_OPERATIONS.LTE]: 'Less than or equal (<=)',
  [WORKER_PATH_OPERATIONS.EQ]: 'Equals (==)',
  [WORKER_PATH_OPERATIONS.NEQ]: 'Not equals (!=)',
  [WORKER_PATH_OPERATIONS.CONTAINS]: 'Contains'
};

export const WORKER_PATH_OPERATIONS_OPTIONS = [
  { value: WORKER_PATH_OPERATIONS.NONE, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.NONE] },
  { value: WORKER_PATH_OPERATIONS.GT, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.GT] },
  { value: WORKER_PATH_OPERATIONS.GTE, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.GTE] },
  { value: WORKER_PATH_OPERATIONS.LT, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.LT] },
  { value: WORKER_PATH_OPERATIONS.LTE, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.LTE] },
  { value: WORKER_PATH_OPERATIONS.EQ, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.EQ] },
  { value: WORKER_PATH_OPERATIONS.NEQ, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.NEQ] },
  { value: WORKER_PATH_OPERATIONS.CONTAINS, label: WORKER_PATH_OPERATIONS_LABELS[WORKER_PATH_OPERATIONS.CONTAINS] }
];

export const WORKER_ACTION_TYPES = {
  SEND: 'SEND',
  SKIP: 'SKIP',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE'
};

export const WORKER_ACTION_TYPES_LABELS = {
  [WORKER_ACTION_TYPES.SEND]: 'Send Notification',
  [WORKER_ACTION_TYPES.SKIP]: 'Skip',
  [WORKER_ACTION_TYPES.UPDATE_MESSAGE]: 'Update Message'
};

export const WORKER_ACTION_TYPES_OPTIONS = [
  { value: WORKER_ACTION_TYPES.SEND, label: WORKER_ACTION_TYPES_LABELS[WORKER_ACTION_TYPES.SEND] },
  { value: WORKER_ACTION_TYPES.SKIP, label: WORKER_ACTION_TYPES_LABELS[WORKER_ACTION_TYPES.SKIP] },
  { value: WORKER_ACTION_TYPES.UPDATE_MESSAGE, label: WORKER_ACTION_TYPES_LABELS[WORKER_ACTION_TYPES.UPDATE_MESSAGE] },
];
